import { Flex, Text } from '@mantine/core';
import { AcceptanceStatus, DocumentStatus } from '@dealstack/shared/lib/generated';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon';
import { getTranslationFromStatus } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageInvestments/utils/investment.helper.ts';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { EXPECTED_STATUS } from '@dealstack/shared/lib/common/business/kyc';
import {
	getColorFromStatus,
	getIconFromStatus,
	getKycStatusColor,
	KycFileDisplayStatus,
} from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageInvestments/utils/statusStyling.helper.ts';
import { TooltipBox } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageInvestments/components/TooltipBox.tsx';

interface Props {
	status: AcceptanceStatus | DocumentStatus | KycFileDisplayStatus;
	items: { text: string }[];
	overrideCount?: number;
	isKyc?: boolean;
}

export const StatusTooltipCount = ({ status, items, overrideCount, isKyc = false }: Props) => {
	const tMipManage = useTranslationMipManage();

	const count = typeof overrideCount === 'number' ? overrideCount : items.length;
	const icon = getIconFromStatus(status);
	const baseColor = isKyc ? getKycStatusColor(status) : getColorFromStatus(status);
	const statusColor = count ? baseColor : 'gray.6';
	const textColor = count ? 'dark.9' : 'gray.6';
	const label =
		status === EXPECTED_STATUS
			? tMipManage('kyc_status.expected')
			: getTranslationFromStatus(status, tMipManage);

	return (
		<TooltipBox
			label={
				<Flex direction="column" gap="0.25rem">
					<Flex align="center" gap="0.25rem">
						<Flex
							h="6px"
							w="6px"
							bg={statusColor}
							style={{ borderRadius: '50%' }}
						></Flex>
						<Text fz="sm" fw={400} c="dark.9">
							{label}
						</Text>
					</Flex>

					{!!items.length &&
						items.map(({ text }) => (
							<Flex direction="column" p="0.25rem" key={text}>
								<Text fz="sm" fw={600} c="dark.9">
									{text}
								</Text>
							</Flex>
						))}
				</Flex>
			}
			isDisabled={!count}
		>
			<Flex align="center" gap="0.25rem" c={statusColor}>
				{icon && <Icon variant={icon} size="lg" />}
				<Text fw={600} c={textColor}>
					{count}
				</Text>
			</Flex>
		</TooltipBox>
	);
};
